import { Button } from "./Button";

type Props = {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmModal({
  title,
  message,
  confirmLabel = "Подтвердить",
  danger = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div
      className="fixed inset-0 z-[120] grid place-items-center"
      style={{ background: "rgba(28,28,28,0.55)", backdropFilter: "blur(6px)" }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-lg shadow-lg fade-up p-7 grid gap-4"
        style={{ width: "min(420px, 92vw)" }}
      >
        <h3 className="font-display font-extrabold text-[20px] tracking-tight">{title}</h3>
        <p className="text-[13.5px] text-ink-60 leading-relaxed">{message}</p>
        <div className="flex gap-2.5 justify-end pt-1">
          <Button variant="outline" size="sm" onClick={onCancel}>
            Отмена
          </Button>
          <button
            onClick={onConfirm}
            className={
              danger
                ? "inline-flex items-center justify-center rounded-pill font-display font-semibold whitespace-nowrap px-3 py-1.5 text-[13px] bg-[var(--wb-danger)] text-white hover:opacity-90 active:scale-[0.98] transition-[background,transform] duration-100"
                : "inline-flex items-center justify-center rounded-pill font-display font-semibold whitespace-nowrap px-3 py-1.5 text-[13px] bg-ink text-white hover:bg-[#2A2A2A] active:scale-[0.98] transition-[background,transform] duration-100"
            }
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
